import Vue from 'vue'
import { reactive, computed, watch, toRefs } from '@vue/composition-api'
import { merge } from 'lodash'


const STORAGE_KEY = 'filter_'
const DEFAULT_ITEMS_PER_PAGE = 10

export function isEmpty(value) {
  return value === undefined ||
         value === null ||
         (typeof value === 'object' && Object.keys(value).length === 0) ||
         (typeof value === 'string' && value.trim().length === 0)
}

export function convertOptions(options) {
  const convertedOptions = {}

  if (options) {

    if (options.page) {
      convertedOptions.page = options.page
    }
    convertedOptions['per-page'] = options.itemsPerPage || null

    if (Array.isArray(options.sortBy) && options.sortBy[0]) {
      convertedOptions.sort = (Array.isArray(options.sortDesc) && options.sortDesc[0] ? '-' : '') + options.sortBy[0]
    }
  }

  return convertedOptions
}


export function createSearch(client, resource, options) {

  const internal = {
    params: options.params || {},

    filterRules: options.filterRules || {},
    loadDefaultFilterRules: true,

    storeFilter: options.storeFilter || false,
    debug: options.debug || false,

    defaultFilterRule: merge({}, { value: val => val, skipOnEmpty: true, operator: 'eq', isEmpty: val => isEmpty(val) }, options.defaultFilterRule),
    watchOptions: options.watchOptions || true,
  }

  const state = reactive({
    items: [],
    isSearching: false,

    params: {},
    filter: options.filter || {},
    options: merge({ itemsPerPage: DEFAULT_ITEMS_PER_PAGE }, options.options),

    currentPage: null,
    pageCount: null,
    perPage: null,
    totalCount: null,
  })

  if (internal.watchOptions) {
    watch(() => state.options, () => {
      search()
    }, { deep: true })
  }

  // store
  if (internal.storeFilter === true) {
    internal.storeFilter = STORAGE_KEY + resource
  }

  if (internal.storeFilter) {
    const store = JSON.parse(sessionStorage.getItem(internal.storeFilter)) || {}

    state.params = store.params || {}
    state.filter = store.filter || {}
    state.options = store.options || {}
  }

  // filters
  if (internal.loadDefaultFilterRules) {
    internal.filterRules = merge({
        query: { value: val => val.split(' '), operator: 'like' },
        // ..
      }, internal.filterRules)
  }

  function setFilterRule(name, options) {
    internal.filterRules[name] = merge({}, internal.defaultFilterRule, options)
  }

  Object.keys(internal.filterRules).forEach(name => {
    setFilterRule(name, internal.filterRules[name])
  })





  const isBusy = computed(() => state.isSearching)

  function debug() {
    internal.debug && console.log(resource, ...arguments)
  }

  function getParams() {

    // process filter
    const filter = {}

    Object.keys(state.filter).forEach(key => {
      let rule = internal.filterRules[key] || internal.defaultFilterRule

      if (!rule.isEmpty(state.filter[key]) || !rule.skipOnEmpty) {
        (filter[key] = {})[rule.operator] = rule.value(state.filter[key])
      }
    })

    return merge({}, internal.params, state.params, { filter: filter }, convertOptions(state.options))
  }


  function search(params) {

    state.isSearching = true

    if (params) {
      state.params = params
    }

    if (internal.storeFilter) {
      sessionStorage.setItem(internal.storeFilter, JSON.stringify({ params: state.params, filter: state.filter, options: state.options }))
    }

    return client.get(resource, { params: getParams() })
      .then(response => {
        state.items = response.data || []
        state.currentPage = response.headers['x-pagination-current-page'] ? Number(response.headers['x-pagination-current-page']) : null,
        state.pageCount = response.headers['x-pagination-page-count'] ? Number(response.headers['x-pagination-page-count']) : null,
        state.perPage = response.headers['x-pagination-per-page'] ? Number(response.headers['x-pagination-per-page']) : null,
        state.totalCount = response.headers['x-pagination-total-count'] ? Number(response.headers['x-pagination-total-count']) : null,
        state.isSearching = false
        return Promise.resolve(response)
      })
      .catch(error => {
        state.isSearching = 'error'
        return Promise.reject(error)
      })

  }

  function reset() {
    state.items = []
    state.params = {}
    state.filter = {}
    state.currentPage = null
    state.pageCount = null
    state.perPage = null
    state.totalCount = null
    state.options = merge({ itemsPerPage: DEFAULT_ITEMS_PER_PAGE }, options.options)
    return this
  }

  function resetFilter(name) {
    if (name) {
      Vue.set(state.filter, name, null)
    } else {
      state.filter = {}
    }
    return this
  }

  function setFilter(name, value) {
    Vue.set(state.filter, name, value)
    return this
  }

  function getItems() {
    return state.items
  }

  function searchOnce(params) {
    if (state.items.length) {
      return Promise.resolve()
    }

    return search(params)
  }

  return {
    ...toRefs(state),
    isBusy,
    search,
    getItems,

    reset,
    setFilter,
    resetFilter,
    searchOnce,
    
    // hasFilter,
  }


}
